<template>
  <v-app class="abeja-app">
    <the-loading v-if="isLoading" />
    <the-toasts :toasts-stack="toastStack" />
    <full-page-template v-if="!isAppTemplate">
      <router-view />
    </full-page-template>
    <app-template v-else>
      <router-view />
    </app-template>
  </v-app>
</template>

<script>
import AppTemplate from '@/components/Template/AppTemplate.vue'
import FullPageTemplate from '@/components/Template/FullPageTemplate.vue'
import TheLoading from '@/components/TheLoading.vue'
import TheToasts from '@/components/TheToasts.vue'
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  name: 'App',
  components: {
    AppTemplate,
    FullPageTemplate,
    TheLoading,
    TheToasts
  },
  computed: {
    ...mapGetters(['isLoading',]),
    ...mapGetters('auth', ['isLogin']),
    ...mapState(['toastStack']),
    ...mapState('auth', [
      'email',
      'name',
      'uid'
    ]),
    isAppTemplate () {
      return !this.$route.meta.isFullPage
    }
  },
  mounted () {
    if (this.isAppTemplate) this.mountIntercom()
  },
  watch: {
    isLogin: {
      handler: function(val, _) {
        this.mountIntercom()
        if (val) this.setApiUserAuth()
      }
    }
  },
  methods: {
    ...mapActions('auth', [
      'setApiUserAuth'
    ]),
    mountIntercom () {
      let data = {
        name: 'guest',
      }
      if (this.isLogin) {
        data = {
          name: this.name,
          email: this.email,
          user_id: this.uid
        }
      }
      this.$intercom.boot(data)
      // NOTE: 開くと邪魔なのでデフォルトはshowしないでおく
      // this.$intercom.show()
    }
  }
}
</script>

<style lang="scss" scoped>
.sample {
  margin-left: 50%;
}

.abeja-app {
  position: relative;
  height: 100vh;
  width: 100vw;
  background-color: #fafafa;

  .abeja-app__sidebar {
    position: fixed;
    background-color: white;
    z-index: 100;
  }

  .abeja-app__body {
    position: absolute;
    width: 100%;
    top: 0px;
    overflow: scroll;
  }
  .abeja-app__body__header {
    position: fixed;
    top: 0px;
    width: 100%;
    background-color: white;
    z-index: 10;
  }
  .abeja-app__body__main {
    position: absolute;
    top: 64px;
    width: 100%;
    max-width: 1960px;
    z-index: 0;
  }
}
</style>
